/**
 * Một lần gỡ SW/cache cũ (aza-system / PWA cũ) sau khi migrate sang sotax-workplace.
 * Không chạy lại mỗi session — tránh phá firebase-messaging-sw.
 */
const FCM_MIGRATION_KEY = "social_fcm_sotax_migrate_v1";
function hasServiceWorkerApi() {
    return typeof navigator !== "undefined" && "serviceWorker" in navigator;
}
async function deleteAllCaches() {
    if (typeof caches === "undefined" || !caches.keys) {
        return;
    }
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
}
/**
 * @returns true nếu đã purge và caller nên reload (hoặc đã schedule reload).
 */
export async function purgeStaleServiceWorkers() {
    if (!hasServiceWorkerApi()) {
        return false;
    }
    try {
        if (localStorage.getItem(FCM_MIGRATION_KEY) === "1") {
            return false;
        }
        const registrations = await navigator.serviceWorker.getRegistrations();
        const hasController = !!navigator.serviceWorker.controller;
        if (!registrations.length && !hasController) {
            localStorage.setItem(FCM_MIGRATION_KEY, "1");
            localStorage.removeItem("cmf_token");
            localStorage.removeItem("send_cmf_token");
            return false;
        }
        await Promise.all(registrations.map((r) => r.unregister()));
        await deleteAllCaches();
        localStorage.setItem(FCM_MIGRATION_KEY, "1");
        localStorage.removeItem("cmf_token");
        localStorage.removeItem("send_cmf_token");
        window.location.reload();
        return true;
    }
    catch {
        return false;
    }
}
/** Side-effect khi import — production only. */
if (typeof window !== "undefined" &&
    process.env.NODE_ENV === "production") {
    void purgeStaleServiceWorkers();
}
